// initialed state
export const initialState = () => ({ data: {}, flagsAreLoaded: false });

const state = initialState();

export default state;
